import { Box } from "@chakra-ui/react"
import Embed from "@pathwright/ui/src/components/embed/Embed"
import LoadingCircle from "@pathwright/ui/src/components/loading/LoadingCircle"
import Text from "lib/core/components/text/Text"
import AssessmentWrapper from "./AssessmentWrapper"

const Assessment = function (
  { content, step, handleLegacyContentCompletion },
  context
) {
  const { method } = content

  return (
    <div className="Content__Assessment Content--padded">
      {(() => {
        switch (method) {
          case "embed":
            return <Embed code={content.embed_code} executeScripts={true} />
          case "assessment_editor":
            return (
              <AssessmentWrapper
                assessment={content}
                step={step}
                handleLegacyContentCompletion={handleLegacyContentCompletion}
              />
            )
          case "assessment_listing":
            return (
              <Text
                html={content.external_instructions}
                templateContext={context}
                theme={true}
                latex={true}
              />
            )
          default:
            return (
              <Box className="AssessmentWrapper" minH="300px">
                <LoadingCircle />
              </Box>
            )
          // return (
          //   <p>Error: Could not render assessment with method {method}.</p>
          // )
        }
      })()}
    </div>
  )
}

Assessment.displayName = "Assessment"

export default Assessment
